export default [
  {
    path: '/setting/close-store',
    name: 'setting-close-store',
    component: () => import('@/views/settings/close/CloseStore.vue'),
    meta: {
      pageTitle: 'Tutup Toko',
      breadcrumb: [
        {
          text: 'Pengaturan',
          active: true,
        },
      ],
      public: true,
    },
  },
  {
    path: '/setting/company',
    name: 'setting-company',
    component: () => import('@/views/settings/company/company-list/CompanyList.vue'),
    meta: {
      pageTitle: 'Profil Perusahaan',
      breadcrumb: [
        {
          text: 'Pengaturan',
          active: true,
        },
      ],
      resource: 'setting-company',
      action: 'read',
    },
  },
  // ACCESS CONTROL
  {
    path: '/setting/accessibility',
    name: 'setting-accessibility-list',
    component: () => import('@/views/settings/accessibility/accessibility-list/AccessList.vue'),
    meta: {
      pageTitle: 'Aksesibilitas',
      breadcrumb: [
        {
          text: 'Daftar Jabatan',
          active: true,
        },
      ],
      resource: 'setting-accessibility-list',
      action: 'read',
    },
  },
  {
    path: '/setting/accessibility',
    name: 'setting-accessibility-add',
    component: () => import('@/views/settings/accessibility/accessibility-add/AccessAdd.vue'),
    meta: {
      pageTitle: 'Aksesibilitas',
      breadcrumb: [
        {
          text: 'Daftar Jabatan',
          to: { name: 'setting-accessibility-list' },
        },
        {
          text: 'Tambah',
          active: true,
        },
      ],
      resource: 'setting-accessibility-list',
      action: 'read',
    },
  },
  {
    path: '/setting/accessibility/:id',
    name: 'setting-accessibility-edit',
    component: () => import('@/views/settings/accessibility/accessibility-edit/AccessEdit.vue'),
    meta: {
      pageTitle: 'Aksesibilitas',
      breadcrumb: [
        {
          text: 'Daftar Jabatan',
          to: { name: 'setting-accessibility-list' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      resource: 'setting-accessibility-list',
      action: 'read',
    },
  },

  // USER SETTINGS
  {
    path: '/setting/user',
    name: 'setting-user-list',
    component: () => import('@/views/settings/user/user-list/UserList.vue'),
    meta: {
      pageTitle: 'Data User',
      breadcrumb: [
        {
          text: 'Data User',
          active: true,
        },
      ],
      resource: 'setting-user-list',
      action: 'read',
    },
  },
  {
    path: '/setting/user',
    name: 'setting-user-add',
    component: () => import('@/views/settings/user/user-add/UserAdd.vue'),
    meta: {
      pageTitle: 'Data User',
      breadcrumb: [
        {
          text: 'Data User',
          to: { name: 'setting-user-list' },
        },
        {
          text: 'Tambah',
          active: true,
        },
      ],
      resource: 'setting-user-list',
      action: 'read',
    },
  },
  {
    path: '/setting/user/:id',
    name: 'setting-user-edit',
    component: () => import('@/views/settings/user/user-edit/UserEdit.vue'),
    meta: {
      pageTitle: 'Data User',
      breadcrumb: [
        {
          text: 'Data User',
          to: { name: 'setting-user-list' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      resource: 'setting-user-list',
      action: 'read',
    },
  },
]
